import * as React from "react";
import { Button, Col, Figure, Image, Row } from "react-bootstrap";

interface Props {
	highlights: {
		icon: string,
		title: string,
		bullets: string[]
	}[]
	filters?: boolean
	largeRow:number;
}

export default function Highlights(props: Props) {
	interface Highlight {
		title: string;
		bullets: string[]
		icon: string;
	}

	function HighlightIcon(highlight: Highlight) {
		return (
			<Col>
				<Image
					className="highlight-icon"
					alt={`${highlight.title} pictogram`}
					src={`${highlight.icon}`}
				/>
				{props.filters && <><br /><br /></>}
				<Row
					xs={8}
					className="highlight-title"
				>
					{highlight.title}
				</Row>
				<ul className="highlight-list">
					{highlight.bullets.map((bullet) =>
						<Row>
							<li>
								{bullet}
							</li>
						</Row>
					)}
				</ul>
			</Col>
		);
	}

	return (
		<>
			<Row
				className="highlight-icons "
				xs={2}
				md={2}
				lg={props.largeRow}
			>
				{props.highlights.map((highlight, index) => (
					<HighlightIcon
						key={index}
						title={highlight.title}
						icon={highlight.icon}
						bullets={highlight.bullets}
					/>
				))}
				{props.filters && (
					<>
						<Col xs={12} sm={12} md={6} lg={8} xl={8} style={{ alignItems: 'center', display: "flex" , paddingTop:'2em'}}>
							<p className="filters-text">
								These examples represent just a selection of our possibilities.
								For additional use-cases and information consult our specialists.
							</p>
						</Col>
						<Col style={{ alignItems: 'center', display: "flex" }}>
							<Button href="/contact" variant="eo-primary">Contact</Button>
						</Col>
					</>
				)}
			</Row>
		</>
	);
}
